import styled from 'styled-components';
import { ChevronDownIcon } from '@root/styles/icons';

export const DisclosureTrigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  color: ${({ theme }) => theme.primaryColour};
  text-align: left;
`;

export const TriggerChevron = styled(ChevronDownIcon)<{ $isOpen: boolean }>`
  flex-shrink: 0;
  margin-left: 8px;
  width: 20px;
  height: 20px;
  transition: transform 0.2s ease;
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

export const DisclosureContent = styled.div`
  margin-top: 16px;
`;
